/**
 * ProductIdDetector.js
 * Detects WebId/LotId and Ensemble ID patterns in search terms.
 */

const WEB_LOT_ID_REGEX = /^([a-zA-Z]{2})?[0-9]{3}[\s]?\d{4,11}[a-zA-Z]?$/;
const ENSEMBLE_ID_REGEX = /(^((enr|ens)\d{10}$))|(^1([a-z]|\d){6}$)/;

export const sanitizeDashes = (term) => (term ? term.replace(/-/g, '') : '');

export const stripSpaces = (term) => (term ? term.replace(/\s/g, '') : '');

export const isWebIdOrLotId = (searchTerm) => {
    if (!searchTerm) return false;
    return WEB_LOT_ID_REGEX.test(sanitizeDashes(searchTerm.trim()));
};

export const isEnsembleId = (searchTerm, enabled = false) => {
    if (!enabled || !searchTerm) return false;
    return ENSEMBLE_ID_REGEX.test(searchTerm.trim());
};

export const detectProductId = (searchTerm, enableSearchByWebIdLotIdEnsembleID = false) => {
    if (!enableSearchByWebIdLotIdEnsembleID || !searchTerm)
        return { isProductId: false, type: null, sanitizedTerm: '' };

    const trimmed = searchTerm.trim();

    if (isEnsembleId(trimmed, enableSearchByWebIdLotIdEnsembleID)) {
        return { isProductId: true, type: 'ensembleId', sanitizedTerm: trimmed };
    }

    if (isWebIdOrLotId(trimmed)) {
        return { isProductId: true, type: 'webId', sanitizedTerm: sanitizeDashes(trimmed) };
    }

    return { isProductId: false, type: null, sanitizedTerm: '' };
};

export const buildProductIdRedirectUrl = (pdpUrl, searchTerm, idType) => {
    if (!pdpUrl) return '';
    // Strip existing query params to match old Solr redirect format
    const baseUrl = pdpUrl.split('?')[0];
    const catId = idType === 'ensembleId' ? 'EnsembleId' : 'WebIds';
    return `${baseUrl}?catId=${catId}&redirectTerm=${encodeURIComponent(searchTerm || '')}`;
};

export default detectProductId;
